import { render, staticRenderFns } from "./InterviewCommentComponent.vue?vue&type=template&id=21312d17&"
import script from "./InterviewCommentComponent.vue?vue&type=script&lang=js&"
export * from "./InterviewCommentComponent.vue?vue&type=script&lang=js&"
import style0 from "./InterviewCommentComponent.vue?vue&type=style&index=0&id=21312d17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports